module.exports = __webpack_public_path__ + "img/computer-mouse.1ae348ff.svg";